module.exports = __webpack_public_path__ + "static/media/4-ConsultaIntegradaMadit.341d9cc4.jpg";